import { FC, useEffect, useRef, useState } from 'react'
import { Content, Image, Item, Title } from './styled'
import { Button } from '../styled'
import { useInView } from 'framer-motion'

type Props = {
  title: string
  imageUrl: string
  link: string
}

export const Season: FC<Props> = ({ title, imageUrl, link }) => {
  const [isVisible, setVisible] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { amount: 0.6 })
  const isPatiallyVisible = useInView(ref, { amount: 0 })

  useEffect(() => {
    if (isVisible && !isPatiallyVisible) {
      setVisible(false)
    } else if (!isVisible && isInView) {
      setVisible(true)
    }
  }, [isInView, isPatiallyVisible, isVisible])

  return (
    <Item ref={ref} $isInView={isVisible}>
      <Image src={imageUrl} alt={title} />
      <Content>
        <Title>{title}</Title>
        <Button href={link} target="_blank">
          смотреть трейлер
        </Button>
      </Content>
    </Item>
  )
}
